mutation deleteJobs {
    deleteJobs
}
